//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'

export default {
  components: {
    Button,
    ModalWithTitleBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    supervisorData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    modalWidth() {
      return this.windowWidth < 768 ? 328 : 640
    },
  },
  methods: {
    onClose() {
      this.$emit('close', true)
    },
    onConfirm() {
      this.$emit('confirm', this.supervisorData)
    },
  },
}
